import { CloseOutlined } from '@ant-design/icons';
import { StyledFilterModalCloseButton } from './styles';

type Props = {
    onClose: () => void;
};

const CloseButton: React.FC<Props> = ({ onClose }: Props) => {
    return (
        <StyledFilterModalCloseButton
            onClick={onClose}
            type="default"
            size="small"
            icon={<CloseOutlined size={16} />}
        ></StyledFilterModalCloseButton>
    );
};

export default CloseButton;
